import React, { useMemo, FC } from 'react';
require("./Indent.css");
var styles = {
  "Root": "Indent-module-Root_3Du"
};
const Indent = ({
  level
}) => {
  const list = useMemo(() => {
    return Array.from({
      length: level
    }, (_, index) => /*#__PURE__*/React.createElement("span", {
      key: index
    }));
  }, [level]);
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: styles.Root,
    "aria-level": level
  }, list);
};
export default Indent;
if (process.env.NODE_ENV !== 'production') {
  Indent.displayName = 'Indent';
}